import { hydraUiApi, useHydraUIAPIQuery } from '@/services/api';
import { membershipKeys } from '@/services/db/account/entity';

// Memberships change rarely (a user's set of accounts), so a stale window keeps
// a reopened switcher from refetching on every open.
const MEMBERSHIPS_STALE_TIME = 5 * 60 * 1000; // 5 minutes

/**
 * useAccountMemberships returns the accounts the current login belongs to.
 *
 * Every call is a read against the global DB replica, and the data is consumed
 * only by the open account switcher (the account list and the "Switch accounts"
 * button label). It is therefore fetched lazily: pass `enabled` true only while
 * the switcher panel is open AND account switching is actually usable (not
 * masquerading). Fetching it on every page mount and window focus put avoidable,
 * continuous load on the shared global replica for data most sessions never look
 * at — so the aggressive refetch options were dropped in favour of the `enabled`
 * gate plus a staleTime.
 */
export function useAccountMemberships(enabled: boolean) {
  return useHydraUIAPIQuery({
    queryKey: membershipKeys.list(),
    queryFn: ({ signal }) => hydraUiApi.memberships.list({ signal }),
    queryConfig: {
      enabled,
      staleTime: MEMBERSHIPS_STALE_TIME,
    },
  });
}
